var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:['figures-' + _vm.card.Figure, 'values-' + _vm.card.Value]},[_c('h1',[_vm._v(_vm._s(_vm.card.Value))]),_c('div',{staticClass:"figures",class:_vm.card.Figure}),_c('h1',[_vm._v(_vm._s(_vm.card.Value))])])}
var staticRenderFns = []

export { render, staticRenderFns }